import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	linkedSignal,
} from '@angular/core';
import { IRoutineTemplate } from '@app/pages/settings/interfaces/routine.interfaces';
import { EntityTitleComponent } from '@app/shared/entity-workspace-components/entity-title/entity-title.component';
import { EntityWorkspaceActionsComponent } from '../../entity-workspace-actions/entity-workspace-actions.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { MatTabsModule } from '@angular/material/tabs';
import { RoutineInformationTabComponent } from '../routine-information-tab/routine-information-tab.component';
import { RoutineTasksTabComponent } from '../routine-tasks-tab/routine-tasks-tab.component';
import { Store } from '@ngrx/store';
import { editRoutineTemplate } from '@app/pages/settings/routines/state/routines.actions';
import { AuCloseButtonComponent } from '@app/shared/ui-components/au-close-button/au-close-button.component';
import { NewRightSidebarService } from '@app/layout/new-right-sidebar/services/new-right-sidebar/new-right-sidebar.service';

@Component({
	selector: 'routine-workspace-form',
	imports: [
		EntityTitleComponent,
		EntityWorkspaceActionsComponent,
		NgxTolgeeModule,
		MatTabsModule,
		RoutineInformationTabComponent,
		RoutineTasksTabComponent,
		AuCloseButtonComponent,
	],
	templateUrl: './routine-workspace-form.component.html',
	styleUrl: './routine-workspace-form.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutineWorkspaceFormComponent {
	private readonly store$ = inject(Store);
	private readonly sidebarService = inject(NewRightSidebarService);

	initialConfig = input<IRoutineTemplate>();
	canEditTemplate = computed(() => this.config().organizationPsId !== null);

	config = linkedSignal<IRoutineTemplate>(() => this.initialConfig());

	routineType = computed(() =>
		this.config()?.organizationPsId ? 'custom_routine' : 'standard_routine'
	);

	updateData(event: Partial<IRoutineTemplate>) {
		if (!this.canEditTemplate()) {
			return;
		}
		this.config.set({ ...this.config(), ...event });
		this.store$.dispatch(
			editRoutineTemplate({ routineTemplate: { ...this.config(), ...event } })
		);
	}

	protected closeSidebar() {
		this.sidebarService.close();
	}
}
